module.exports = __webpack_public_path__ + "img/stock7.10e2b819.png";